export default "__VITE_ASSET__Drs7hip3__"